require('./ctxTabs.style.scss');
/***
 *
 * @type {angular.IModule}
 *
 * Usage Template:
 * <cpd-tabs>
 *   <cpd-tab tab-title='Books'> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? </cpd-tab>
 *   <cpd-tab tab-title='Reviews'> At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat. </cpd-tab>
 * </cpd-tabs>
 *
 *
 */
class ctxTabsController {
    constructor($scope, $element, $timeout, $attrs) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$attrs = $attrs;
        this.buttonMode = this.$attrs.buttonMode;
        this.tabs = [];
        this.defaultTab = this.defaultTab || 1;
    }

    register(title, help) {
        let name = 'tab' + this.tabs.length;
        this.tabs.push({name: name, title: title || name, help: help});
        return name;
    }

    switchTab(tab) {
        if(this.active === tab.name) {
            return;
        }
       if(this.onTabChange) {
           this.onTabChange({previous: this.active, active: tab.name}).then(() => {
               this.switchTabAction(tab);
          })
       } else {
           this.switchTabAction(tab);
       }
    }

    switchTabAction(tab) {
        let panesEl = this.$element.find('.panes');
        if(panesEl && panesEl[0]) {
            panesEl.css({height: panesEl[0].getBoundingClientRect().height});
            panesEl.css({overflow: 'hidden'});
            panesEl.find('.ctx-tab-default').css({'display': 'none'});
        }
        this.active = tab.name;
    }

    $postLink() {
        this.setActiveTab();
        this.$scope.$watch(() => this.defaultTab, () => {
            this.setActiveTab();
        })
    }

    setActiveTab() {
        let height =  this.$element && this.$element[0] && this.$element[0].getBoundingClientRect() ? this.$element[0].getBoundingClientRect().height : 0;
        if(height > 0) {
            let tabName = this.tabs[this.defaultTab-1].name;
            if(this.onTabChange) {
                this.onTabChange({previous: tabName, active: tabName}).then(() => {
                    this.active = tabName;
                })
            } else {
                this.active = tabName;
            }
        } else {
            this.$timeout(() => this.setActiveTab(), 0);
        }
    }

}

const ctxTabsComponent = {
    controller: ctxTabsController,
    controllerAs: 'ctxTabsCtrl',
    template: require('./ctxTabs.template.html'),
    transclude: true,
    replace: true,
    scope: {},
    bindings: {
        animateTab: '<?',
        onTabChange: '&?',
        defaultTab: '<?'
    }
};

ctxTabsController.$inject = ['$scope', '$element', '$timeout', '$attrs'];

module.exports = ctxTabsComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTabs/ctxTabs.component.js